export default __webpack_public_path__ + "static/media/money-back.a9adf71a.png";